<template>
	<div id="app">
		<router-view />
	</div>
</template>
<script>
	export default {
		name: 'App',
		components: {},
    mounted() {
      // localStorage.setItem('token','eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiLlvq7kv6HnlKjmiLciLCJjb250ZXh0VXNlcklkIjoib3VtQzA2X2p0SWxpMlEwMzg5UXVNZUZ5NEx6WSIsImNvbnRleHROYW1lIjoi5b6u5L-h55So5oi3IiwibWVyY2hhbnRObyI6IkU4ODg4ODg4ODAiLCJyZW5ld2FsVGltZSI6MTcyMTg4NjY4MzY3Nywic3lzdGVtTm8iOiJzeXN0ZW1ObyIsImV4cCI6MTcyMTg5NzQ4M30.cHu8ibkGxVd71vj5TBYsitFLOKGRROJWWhLXrIFYrEc')
      // localStorage.setItem("token", 'eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIxODQwMjg5MjczNyIsImNvbnRleHRVc2VySWQiOiJvdW1DMDYzeHdsMXYzYlp0cWlYalNrdHM2aXRRIiwiY29udGV4dE5hbWUiOiLlvq7kv6HnlKjmiLciLCJtZXJjaGFudE5vIjoiRTg4ODg4ODg4MCIsInJlbmV3YWxUaW1lIjoxNzY0ODM3NjI0OTcyLCJkZXB0SWQiOiIiLCJzeXN0ZW1ObyI6IjA5MDAwMiIsImRhdGFQZXJtaXQiOiIiLCJleHAiOjE3NjQ4NTkyMjR9.1KgS23wjGK8MIEaEjRqIKx9NjZQKYFxTDgfwUB4qDdE');
    }
	}
</script>

<style>
	@import './assets/css/reset.css';
	@import './assets/css/common.css';
	/* @import './assets/css/font.css'; */
</style>
